<template>
  <div class="bg-surface-canvas dark:bg-surface-level-900">
    <NavigationMain />

    <slot />

    <Footer />
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '~/stores/useUserStore'
import { useIdentity } from '~/composables/useIdentity'

defineSlots<{
  default?: () => unknown
}>()

const { isAuthenticated } = useIdentity()
const userStore = useUserStore()

// Fetch user access data when layout mounts if user is authenticated
onMounted(async () => {
  if (isAuthenticated.value && !userStore.initialized) {
    await userStore.fetchUserAccess()
  }
})
</script>
